import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmEditorModule } from '@portal-core/code-editor/components/cm-editor/cm-editor.module';
import { CodeEditorStatusBarModule } from '@portal-core/code-editor/components/code-editor-status-bar/code-editor-status-bar.module';
import { CodeEditorToolbarModule } from '@portal-core/code-editor/components/code-editor-toolbar/code-editor-toolbar.module';
import { CodeEditorComponent } from './code-editor.component';

@NgModule({
  declarations: [
    CodeEditorComponent
  ],
  imports: [
    CmEditorModule,
    CodeEditorStatusBarModule,
    CodeEditorToolbarModule,
    CommonModule
  ],
  exports: [
    CodeEditorComponent
  ]
})
export class CodeEditorModule { }
